import { APP_AMOUNT_LOCALE } from './constants';

/**
 * Formatowanie kwoty
 */
export const formatAmount = `return value && value.toLocaleString("${APP_AMOUNT_LOCALE}", {minimumFractionDigits: 2, maximumFractionDigits: 2})`;

/**
 * Formatowanie kwoty
 *
 * @export
 * @param {number} value
 * @return
 */
export function formatAmountFunc(value: number) {
  return value && value.toLocaleString(APP_AMOUNT_LOCALE, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
